import React, { useState } from 'react';
import { connect } from 'react-redux';
import ReactGA from 'react-ga';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import ArrepentimientoEstado from './arrepentimiento-estado';
import ArrepentimientoClient from '../../../api/arrepentimiento';
import ConsultasClient from "../../../api/consultas"

function FormularioArrepentimiento(props) {
  const [estadoArrepentimiento, setEstadoArrepentimiento] = useState('cargando');
  const [form, setForm] = useState({
    numeroCompra: '',
    fechaCompra: '',
    comentarios: '',
    nombre: '',
    apellido: '',
    dni: '',
    telefono: '',
    email: '',
    tipoConsulta: "arrepentimiento",
    agenciaId: props.application.applicationId,
    nombreAgencia: props.application.nombre,
    emailAgencia: props.application.templateData.header.emailContacto,
    paisId: props.application.paisId,
  });

  const setearEstado = (event) => {
    setForm({
      ...form,
      [event.target.name]: event.target.value,
    });
  };

  const setearFechaCompra = (date) => {
    setForm({
      ...form,
      fechaCompra: date,
    });
  };

  // const enviarArrepentimiento = (event) => {
  //   event.preventDefault();
  //   const { token } = props.application;
  //   setEstadoArrepentimiento('enviando');
  //   ArrepentimientoClient.reclamo(form, token)
  //     .then((res) => {
  //       ReactGA.event({
  //         category: 'Accion',
  //         action: 'Consultar',
  //         label: 'Arrepentimiento',
  //         nonInteraction: true,
  //       });
  //       if (res.data.status) {
  //         setEstadoArrepentimiento('enviado');
  //       } else {
  //         setEstadoArrepentimiento('error');
  //       }
  //     }).catch(() => {
  //       setEstadoArrepentimiento('error');
  //     });
  // };

  const enviarArrepentimiento = (event) => {
    event.preventDefault()
    const { token } = props.application
    setEstadoArrepentimiento('enviando');
    ConsultasClient.consultaMarcaBlanca(form, token).then((res) => {
      if (res.status === 201) {
        setEstadoArrepentimiento('enviado')
        form.id = res.data.id
        ConsultasClient.enviarMailArrepentimiento(form, token).then((res) => {
          if (res.status === 201) {
            console.log("Email Sent")
          } else {
            console.error("EMAIL - Error")
          }
        })
        alert("La consulta se envió correctamente")
        this.props.history.push("/")
      } else {
        setEstadoArrepentimiento({
          estadoConsulta: "error",
        })
        alert("La consulta no se pudo enviar")
      }
    })
  }

  const formulario = () => {
    return (
      <form onSubmit={enviarArrepentimiento} autoComplete='off'>
        <div className='mb-8'>
          <h2 className='text-lg font-bold text-red-800 mb-2'>
            Formulario de arrepentimiento
          </h2>
          <div className='grid md:grid-cols-2 gap-4 mb-4'>
            <div className='flex flex-col'>
              <label
                className='block text-gray-700 text-sm font-bold mb-2'
                htmlFor='numeroCompra'
              >
                Número de compra(*)
              </label>
              <input
                id='numeroCompra'
                onChange={setearEstado}
                value={form.numeroCompra}
                placeholder='Número de compra'
                name='numeroCompra'
                type='text'
                className='shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight'
                required
              />
            </div>
            <div className='flex flex-col'>
              <label
                className='block text-gray-700 text-sm font-bold mb-2'
                htmlFor='cantidad-dias'
              >
                Fecha de compra(*)
              </label>
              <DatePicker
                dateFormat='dd/MM/yyyy'
                selected={form.fechaCompra}
                onChange={setearFechaCompra}
                maxDate={new Date()}
                className='shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight'
                required
              />
            </div>
          </div>
          <div className='flex flex-col'>
            <label
              className='block text-gray-700 text-sm font-bold mb-2'
              htmlFor='descripcion-reclamo'
            >
              Descripción del reclamo(*)
            </label>
            <textarea
              id='comentarios'
              name='comentarios'
              value={form.comentarios}
              onChange={setearEstado}
              placeholder='Describe el motivo del reclamo o cancelación'
              className='h-36 shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight'
              required
            />
          </div>
        </div>
        <div className='mb-8'>
          <h2 className='text-lg font-bold text-red-800 mb-2'>Completa los datos del cliente</h2>
          <div className='grid md:grid-cols-2 lg:grid-cols-4 gap-4'>
            <div className='flex flex-col'>
              <label
                className='block text-gray-700 text-sm font-bold mb-2'
                htmlFor='nombre'
              >
                Nombre(*)
              </label>
              <input
                id='nombre'
                onChange={setearEstado}
                value={form.nombre}
                name='nombre'
                type='text'
                className='shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight'
                required
              />
            </div>
            <div className='flex flex-col'>
              <label
                className='block text-gray-700 text-sm font-bold mb-2'
                htmlFor='apellido'
              >
                Apellido(*)
              </label>
              <input
                id='apellido'
                onChange={setearEstado}
                value={form.apellido}
                name='apellido'
                type='text'
                className='shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight'
                required
              />
            </div>
            <div className='flex flex-col'>
              <label
                className='block text-gray-700 text-sm font-bold mb-2'
                htmlFor='email'
              >
                E-mail(*)
              </label>
              <input
                id='email'
                onChange={setearEstado}
                value={form.email}
                name='email'
                type='email'
                className='shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight'
                required
              />
            </div>
            <div className='flex flex-col'>
              <label
                className='block text-gray-700 text-sm font-bold mb-2'
                htmlFor='telefono'
              >
                Teléfono(*)
              </label>
              <input
                id='telefono'
                onChange={setearEstado}
                value={form.telefono}
                name='telefono'
                type='number'
                className='shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight'
                required
              />
            </div>
          </div>
        </div>
        <div className='flex'>
          <button type='submit' className='ml-auto border border-red-800 text-red-800 transition duration-300 hover:bg-red-100 font-semibold py-2 px-8 rounded focus:outline-none'>
            Enviar reclamo
          </button>
        </div>
      </form>
    );
  };

  switch (estadoArrepentimiento) {
    case 'cargando':
      return formulario();
    case 'enviando':
      return (
        <ArrepentimientoEstado><b>Enviando su reclamo ...</b></ArrepentimientoEstado>
      );
    case 'enviado':
      return (
        <ArrepentimientoEstado><b>Todo listo! Tu reclamo fue enviado correctamente</b></ArrepentimientoEstado>
      );
    case 'error':
      return (
        <ArrepentimientoEstado>
          <b>
            Ocurrió un error procesando tu consulta. Intentelo nuevamente o contactese con nosotros
            telefonicamente
          </b>
        </ArrepentimientoEstado>
      );
  }

}

const mapStateToProps = (state) => ({
  application: state.applicationState,
});

export default connect(mapStateToProps, null)(FormularioArrepentimiento);
